import { gql } from "@apollo/client";

export const GET_MOTIVOS_RECHAZO = gql`
query allRechazoNIngreso{
    allRechazoNIngreso {
        idRechazoNIngreso,
        idMotivoNIngreso,
        descripcion
    }
  }
`;

export const adaptMotivoRechazo = (motivo) => ({
  id: motivo.idRechazoNIngreso,
  displayName: motivo.descripcion,
  motivoNIngreso: motivo.idMotivoNIngreso
});

export const adaptMotivoRechazoArray = (motivos) =>
structuredClone(motivos?.allRechazoNIngreso)?.
map((motivo) => adaptMotivoRechazo(motivo));